import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { M2DataUploadTable } from "./table";
import { M2DataUploadEdit } from "./edit";

export default function M2DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<M2DataUploadEdit />} />
      <Route index element={<M2DataUploadTable />} />
    </Routes>
  );
}
